module.exports = __webpack_public_path__ + "static/flags/IN-54c12f53590653f81e5b77f16ce45fc4.gif";